module.exports = __webpack_public_path__ + "img/coach-progress-good.e808eefe.svg";